import { render, staticRenderFns } from "./profile-comments.vue?vue&type=template&id=3bb79c6a&scoped=true"
import script from "./profile-comments.vue?vue&type=script&lang=js"
export * from "./profile-comments.vue?vue&type=script&lang=js"
import style0 from "./profile-comments.vue?vue&type=style&index=0&id=3bb79c6a&prod&scoped=true&lang=scss"
import style1 from "./profile-comments.vue?vue&type=style&index=1&id=3bb79c6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb79c6a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconNoteEye: require('/app/components/v2/icons/IconNoteEye.vue').default,IconQuastion: require('/app/components/v2/icons/IconQuastion.vue').default,VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
